import React, { useContext, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import ForgotPasswordCard from './sections/ForgotPasswordCard/ForgotPasswordCard';
import Footer from '../../../shared/components/v3/Footer/Footer';
import Toast from '../../../shared/components/v3/Toast/Toast';
import { LOGIN_ROUTE } from '../../../shared/constants/auth';
import { GENERIC_ERROR_TOAST } from '../../../shared/constants/toast';
import { SessionContext } from '../../../shared/context/auth/authContext';

const ForgotPassword = () => {
  const [errorToast, setErrorToast] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as { email?: string } | null;
  const email = state?.email || '';

  const { t } = useTranslation();

  const { errorCode, resetError } = useContext(SessionContext);

  useEffect(() => {
    if (!email) {
      navigate(LOGIN_ROUTE);
    }
  }, [email, navigate]);

  useEffect(() => {
    if (errorCode) {
      setErrorToast(true);
      resetError('');
    }
  }, [errorCode, resetError]);

  return (
    <>
      <div className="auth-container" data-experience="new">
        <ForgotPasswordCard email={email} />
      </div>
      <Footer login={true} />
      <Toast
        title={t(GENERIC_ERROR_TOAST.title)}
        description={t(GENERIC_ERROR_TOAST.description)}
        icon={GENERIC_ERROR_TOAST.icon}
        open={errorToast}
        button={true}
        handleClose={() => setErrorToast(false)}
      />
    </>
  );
};

export default ForgotPassword;
